"use client";

import { c as _c } from "react/compiler-runtime";
import { Coin, CoinPair } from "@pools/types";
import { memo } from "react";
import { cx } from "@/utils/cx";
import { usePoolsFilters } from "../../hooks";
import { TokenIconOnly } from "../TokenIcon";
const PairTypeCard = memo(t0 => {
  const $ = _c(24);
  const {
    pairs,
    isSelected,
    onSelectPair,
    pair
  } = t0;
  if (pairs.length !== 2) {
    throw new Error("Must have two coins");
  }
  const [t1, t2] = pairs;
  const {
    symbol: firstSymbol
  } = t1;
  const {
    symbol: secondSymbol
  } = t2;
  let t3;
  if ($[0] !== isSelected || $[1] !== onSelectPair || $[2] !== pair) {
    t3 = () => onSelectPair(isSelected ? null : pair);
    $[0] = isSelected;
    $[1] = onSelectPair;
    $[2] = pair;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isSelected ? "border-brand bg-brand-primary shadow-sm" : "border-border-primary bg-primary";
  let t5;
  if ($[4] !== t4) {
    t5 = cx("flex pressable flex-col items-center justify-center gap-1.5 rounded-lg border px-2 py-4 text-center transition-[colors,box-shadow] duration-200 hover:border-brand hover:bg-brand-primary", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== firstSymbol) {
    t6 = <TokenIconOnly symbol={firstSymbol} size="lg" className="relative z-10 -mr-2 drop-shadow-sm" />;
    $[6] = firstSymbol;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== secondSymbol) {
    t7 = <TokenIconOnly symbol={secondSymbol} size="lg" className="relative z-0 -ml-2 drop-shadow-sm" />;
    $[8] = secondSymbol;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="flex flex-row items-center justify-center">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = isSelected ? "text-text-primary" : "text-text-secondary";
  let t10;
  if ($[13] !== t9) {
    t10 = cx("text-sm font-normal", t9);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== firstSymbol || $[16] !== secondSymbol || $[17] !== t10) {
    t11 = <p className={t10}>{firstSymbol} / {secondSymbol}</p>;
    $[15] = firstSymbol;
    $[16] = secondSymbol;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t3 || $[21] !== t5 || $[22] !== t8) {
    t12 = <button onClick={t3} className={t5}>{t8}{t11}</button>;
    $[19] = t11;
    $[20] = t3;
    $[21] = t5;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
});
export default function PoolsPairs(t0) {
  const $ = _c(7);
  const {
    pairs,
    selectedCoinPair: controlledSelectedCoinPair,
    onSelectPair
  } = t0;
  const {
    selectedCoinPair,
    setSelectedCoinPair
  } = usePoolsFilters();
  const activeSelectedCoinPair = controlledSelectedCoinPair ?? selectedCoinPair;
  const handleSelectPair = onSelectPair ?? setSelectedCoinPair;
  if (Array.isArray(pairs) && !pairs.length) {
    throw new Error("Must have at least one pair");
  }
  let t1;
  if ($[0] !== activeSelectedCoinPair?.id || $[1] !== handleSelectPair || $[2] !== pairs) {
    let t2;
    if ($[4] !== activeSelectedCoinPair?.id || $[5] !== handleSelectPair) {
      t2 = pair => <PairTypeCard key={pair.id} pair={pair} pairs={pair.pairs} isSelected={activeSelectedCoinPair?.id === pair.id} onSelectPair={handleSelectPair} />;
      $[4] = activeSelectedCoinPair?.id;
      $[5] = handleSelectPair;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = pairs.map(t2);
    $[0] = activeSelectedCoinPair?.id;
    $[1] = handleSelectPair;
    $[2] = pairs;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
PoolsPairs.PairCard = PairTypeCard;